module.exports = __webpack_public_path__ + "static/media/castleGate.97807e2f.mp3";